import { handleApiError } from "../../../utils/errors";
import { getAuthHeader } from "../../../utils/superagent";
import request from "superagent";

export async function getHostedTimeFacility(userId: string) {
  return await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .get(`${global.api}/hosted-time/facility/${userId}`)
    .set(await getAuthHeader())
    .then(({ body }) => body.data)
    .catch((error) => handleApiError(error));
}

export async function putHostedTimeFacility({
  userId,
  name,
  deviceId,
}: {
  userId: string;
  name: string;
  deviceId: number;
}) {
  return await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .put(`${global.api}/hosted-time/facility/${userId}`)
    .set(await getAuthHeader())
    .send({ name, deviceId })
    .then(({ body }) => body.message)
    .catch((error) => handleApiError(error));
}
